'use strict';
import {FORM_INSTANCE_COLLECTION} from './config';


module.exports = function () {
  return {
    $get: [
      'FirebaseUtil',
      'AbstractDomainClass',
      '$filter',
      function (
        FirebaseUtil,
        AbstractDomainClass,
        $filter,
      ) {
        function FormInstanceDomain(data) {
          AbstractDomainClass.call(this, FormInstanceDomain, data);
        }

        AbstractDomainClass.__inheritFrom(FormInstanceDomain, 'FormInstanceDomain', FORM_INSTANCE_COLLECTION);

        // Join table between forms and things that have potentially multiple form responses
        FormInstanceDomain.$constraints.addConstraints({
          //name: {type: 'string'},
          form: {type: 'string'}, // domainClass: FormDomain id
          formVersion: {type: 'string'},
          target: {type: 'DomainLink', belongsTo: true, nullable: true},

          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          formResponses: {type: 'DomainCollection', domainClass: 'FormResponseDomain', link: 'target', belongsTo: true}
        });

        // more methods go here;

        FormInstanceDomain.prototype.toString = function () {
          var name = this.form && this.form.name;
          var by = this.createdBy && this.createdBy.toString();
          return name + ' submitted by ' + by + ' on ' + $filter('date')(this.lastUpdated);
        };

        return FormInstanceDomain;
      }]
  };
};



// WEBPACK FOOTER //
// ./src/js/forms/domain/FormInstanceDomain.js